import { baseFetch } from '../../baseFetch';
import { ExitStatusResponseSchema } from '../../schemas/ExitStatusResponseSchema';
import { SubmitSalesProjectResponseSchema } from './sales-projects.schema';

export interface SalesProjectOrder {
  id?: number | null;
  uuid?: string | null;
  org_id?: number | null;
  client_orgs?: Array<{ id: number }> | null;
  data_collection_org_id?: number | null;
  data_collection_manager_id?: number | null;
  pm_user_id?: number | null;
  order_type?: string | null;
  contract_type?: string | null;
  site_contact_uuid?: string | null;
  requested_delivery_date?: number | null;
  requested_flight_date?: number | null;
  turnkey_services?: boolean | null;
  solar_farm: Record<string, unknown>;
  solar_farm_uuid?: string | null;
  services?: Array<Record<string, unknown>> | null;
  accounting_info_items?: Array<{
    accounting_item_codekey: string;
    amount: string;
  }> | null;
  updator_id?: number | null;
  mailing_list?: string[] | null;
}

export interface SubmitSalesProjectRequest {
  id?: number | null;
  project_name?: string | null;
  org_id?: number | null;
  project_manager_id?: number | null;
  creator_id?: number | null;
  updator_id?: number | null;
  hubspot_deal_url?: string | null;
  proposal_url?: string | null;
  dsp_contract_url?: string | null;
  status?: number | null;
  email_list?: string[] | null;
  other_context?: string | null;
  solar_orders?: SalesProjectOrder[] | null;
}

export interface SubmitSalesOnboardingRequest {
  project_name: string;
  order_list: SalesProjectOrder[];
  other_context?: string | null;
  signed_proposal_link: string;
  dsp_contract_link: string;
  mailing_list: string[];
  pm_user_id: number;
  data_collection_manager_id: number;
  hubspot_deal_url: string;
}

export const submitSalesProject = (
  salesProjectId: number,
  body: SubmitSalesProjectRequest,
) => {
  return baseFetch(
    'internal-v2',
    `/sales_project/${salesProjectId}/submit`,
    SubmitSalesProjectResponseSchema.defined(),
    { method: 'POST', requestBody: body },
  );
};

export const submitSalesOnboarding = (body: SubmitSalesOnboardingRequest) => {
  return baseFetch(
    'internal-v2',
    '/admin/submit_sales_onboarding',
    ExitStatusResponseSchema.defined(),
    { method: 'POST', requestBody: body },
  );
};
